import { type TableSelectedCell, useTableRows } from '@/components/custom/erp';

export interface TaxRow {
  uuid?: string | null;
}

export type SelectedCellInfo = TableSelectedCell;

export function useTaxRows(initialRows: TaxRow[] = [], onChange?: (rows: TaxRow[]) => void) {
  const {
    rows,
    setRows,
    selectedRowUuid,
    setSelectedRowUuid,
    selectedRow,
    setSelectedRow,
    selectedCell,
    setSelectedCell,
    handleRowClick,
    handleCellClick,
    clearSelection,
    handleCellValueChange,
    handleAddRow,
    handleDeleteRow,
    handleCopyRow,
    handlePasteRow,
    handleMoveRow,
    setNonWritableFields,
    setPasteConfigs,
    isPasting
  } = useTableRows<any>({
    initialRows,
    defaultRows: 0,
    onChange,
    defaultField: 'ma_thue'
  });

  return {
    rows,
    setRows,
    selectedRowUuid,
    selectedRow,
    selectedCell,
    handleRowClick,
    handleCellClick,
    clearSelection,
    handleAddRow,
    handleDeleteRow,
    handleCopyRow,
    handlePasteRow,
    handleMoveRow,
    handleCellValueChange,
    setNonWritableFields,
    setPasteConfigs,
    setSelectedCell,
    setSelectedRow,
    isPasting
  };
}
